import React from 'react';
import TweenOne from 'rc-tween-one';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import { getChildrenToRender } from './utils';

import Icon from '../../icon/Icon';

function Content4(props) {
  const { ...tagProps } = props;
  const { dataSource } = tagProps;
  delete tagProps.dataSource;
  delete tagProps.isMobile;
  const animation = {
    y: '+=30',
    opacity: 0,
    type: 'from',
    ease: 'easeOutQuad',
  };

  return (
    <div {...tagProps} {...dataSource.wrapper}>
      <div {...dataSource.page}>
        <div key="title" {...dataSource.titleWrapper}>
          {dataSource.titleWrapper.children.map(getChildrenToRender)}
        </div>
        <OverPack {...dataSource.OverPack}>
          <TweenOne
            key="video"
            animation={{ ...animation, delay: 300 }}
          >
            <div className="iframe-container">
              {dataSource.embededVideo.children}
            </div>
            <div className="clickable" style={{textAlign: 'center', marginTop: '24px'}}>
              <Icon onClick={() => {
                var x = document.getElementById('Feature0_0')
                if(x)
                    x.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center',
                        inline: 'center',
                    });
              }} name="angle-down" size={2} />
            </div>
          </TweenOne>
        </OverPack>
      </div>
    </div>
  );
}

export default Content4;
